"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "calatabiano": {
    "4a49b774": [{
      "hkey": "e02ecbfc",
      "slug": "calatabiano",
      "name": "Calatabiano",
      "primary": true,
      "skipSearch": false
    }],
    "ciotto": [{
      "hkey": "e02ecbfc",
      "slug": "calatabiano",
      "name": "Calatabiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dee545fd": [{
      "hkey": "1bdc4272",
      "slug": "pasteria-lapide",
      "name": "Pasteria-Lapide",
      "primary": true,
      "skipSearch": false
    }],
    "lapide": [{
      "hkey": "1bdc4272",
      "slug": "pasteria-lapide",
      "name": "Pasteria-Lapide",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "calatabiano"
    }],
    "b7b02e36": [{
      "hkey": "1bdc4272",
      "slug": "pasteria-lapide",
      "name": "Pasteria-Lapide",
      "primary": true,
      "skipSearch": false
    }],
    "pateria": [{
      "hkey": "1bdc4272",
      "slug": "pasteria-lapide",
      "name": "Pasteria-Lapide",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7a1472e4": [{
      "hkey": "e02ecbfc",
      "slug": "calatabiano",
      "name": "Calatabiano",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "e02ecbfc",
      "slug": "calatabiano",
      "name": "Calatabiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;